import { useFieldArray, useFormContext } from "react-hook-form";
import { GetPreferenceResponse } from "@/types/api/api-types";
import { WineColorEnum } from "@/constants/enums/wineColor.enum";
import { WineListElem } from "./wineListElem";
import { CotationUpdateBoFormData } from "@/types/forms/bo/cotationUpdateBoForm.form";
import { useTranslation } from "react-i18next";

interface InfoBottlesProps {
  preference?: GetPreferenceResponse;
  hasScannedInvoice?: boolean;
}

export const InfoBottles = ({ preference, hasScannedInvoice = false }: InfoBottlesProps) => {
  const { t } = useTranslation("boExpeditions");
  const methods = useFormContext<CotationUpdateBoFormData>();
  const deliveryContent = useFieldArray({
    control: methods.control,
    name: "deliveryContent",
  });

  const handleAddProduct = async () => {
    const newDeliveryContentValue = hasScannedInvoice
      ? {
          wineName: "xxxx",
          year: undefined as unknown as number,
          alcoholPercent: 0,
          volume: undefined as unknown as number,
          color: WineColorEnum.ROUGE,
          quantity: undefined as unknown as number,
          price: undefined as unknown as number,
          isEditing: true,
        }
      : {
          wineName: "",
          year: undefined,
          alcoholPercent: undefined as unknown as number,
          volume: undefined as unknown as number,
          color: undefined as unknown as WineColorEnum,
          price: undefined as unknown as number,
          quantity: undefined as unknown as number,
          isEditing: true,
        };

    deliveryContent.append(newDeliveryContentValue);
  };

  const handleRemoveProduct = (index: number) => {
    deliveryContent.remove(index);
  };

  return (
    <div className="shadow-basic flex w-full flex-col items-center justify-center rounded-xl border border-gray-200 bg-white p-4 sm:p-6 md:max-w-[1000px]">
      <div className="flex w-full flex-col items-center justify-center gap-4">
        <h2 className="text-brand700 text-xl font-semibold">
          {t("pendingShipmentsBottlesInfo.title")}
        </h2>
        <div className="flex w-full flex-col gap-2">
          {deliveryContent.fields.map((field, index: number) => (
            <WineListElem
              key={field.id}
              item={field}
              index={index}
              remove={handleRemoveProduct}
              error={methods.formState.errors.deliveryContent?.[index] !== undefined}
              hasScannedInvoice={hasScannedInvoice}
              preference={preference}
              deliveryContentLength={deliveryContent.fields.length}
            />
          ))}
        </div>
        <div className="flex w-full flex-row items-center justify-end gap-3">
          <button
            onClick={handleAddProduct}
            type="button"
            className="text-brand700 rounded-lg bg-blue-50 px-4 py-3 text-sm font-semibold hover:bg-blue-300 disabled:cursor-not-allowed disabled:text-gray-500 disabled:hover:bg-blue-50"
          >
            {t("pendingShipmentsBottlesInfo.addBottle")}
          </button>
        </div>
      </div>
    </div>
  );
};
